import { ThemeType, ThemeTypeList } from "../../constants/theme";
import { IModalType, ModalProps, ModalType } from ".";
import { css } from "styled-components";

export const getModalStyle = (p: ModalProps) => {
  return (
    {
      [ThemeTypeList.TASK_EVA]: {
        [ModalType.Confirm]: {
          global: css`
            .task-eva-modal-inner-wrapper {
              width: max-content;
            }
          `,
          title: css`
            margin: 10px 0 0;
            padding: 0 0 0 14px;
            color: #fff;
          `,
          footer: css`
            bottom: 12px;
            button {
              width: 86px;
              height: 28px;
              color: #fff;
              &:first-child {
                margin-right: 12px !important;
              }
            }
          `,
          closeIcon: css`
            top: 11px;
            right: 14px;
          `,
        },
      }[p.type],
      [ThemeTypeList.USER_CENTER]: {
        [ModalType.Confirm]: {
          global: css``,
          title: css``,
          footer: css``,
          closeIcon: css``,
        },
      }[p.type],
    }[p.themeType] || css``
  );
};
